import React from 'react';
import PropTypes from 'prop-types';
import Metrics from '@spotahome/soyuz-tracking';
import CurrencyFormatter from '@spotahome/marketplace-common/src/utils/CurrencyFormatter';
import HomeCard from '@spotahome/marketplace-common/src/components/Homecard';

import './FavoritesHomecard.scss';

const FavoritesHomecard = props => {
  const {
    homecard,
    onClick,
    onToggleFavorite,
    showAvailableFromYear,
    isRebrandingStyle,
    renderExtraContent
  } = props;

  const { currencyLabel, currencySymbol, currencyIsoCode } = homecard;

  const currency = new CurrencyFormatter(
    currencyLabel,
    currencySymbol,
    currencyIsoCode
  );

  const handleHomecardClick = () => {
    Metrics.ga.sendEvent('Favorites', 'view favorite', 'click homecard');
    onClick();
  };
  return (
    <div className={'favorites-home-card__wrapper'}>
      <HomeCard
        data={{
          ...homecard,
          isFavorite: true
        }}
        onToggleFavorite={onToggleFavorite}
        currency={currency}
        onClick={handleHomecardClick}
        showAvailableFromYear={showAvailableFromYear}
        isRebrandingStyle={isRebrandingStyle}
        renderExtraContent={renderExtraContent}
      />
    </div>
  );
};

FavoritesHomecard.propTypes = {
  homecard: PropTypes.shape({
    id: PropTypes.string,
    currencyLabel: PropTypes.string,
    currencySymbol: PropTypes.string,
    currencyIsoCode: PropTypes.string
  }).isRequired,
  onClick: PropTypes.func,
  onToggleFavorite: PropTypes.func,
  showAvailableFromYear: PropTypes.bool,
  isRebrandingStyle: PropTypes.bool,
  renderExtraContent: PropTypes.func
};

FavoritesHomecard.defaultProps = {
  onClick: () => {},
  onToggleFavorite: () => {},
  showAvailableFromYear: false,
  isRebrandingStyle: false,
  renderExtraContent: () => {}
};

export default FavoritesHomecard;
